import * as React from 'react';
import { times } from 'lodash';
import { Button } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { IEmailTypes } from '../EmailsConfiguration';
import { tableLoading, tableLoadingButton } from 'src/modules/Alert/ControlCenter/utils/placeholders';
import { IEmailConfiguration } from 'src/share/types/emailsConfiguration';

export interface IEmailCategoryProps {
  emailsConfiguration: IEmailConfiguration[];
  onHandleModal: (emailId) => void;
  loading: boolean;
}

const addSeparationOnEmails = (users) => users.slice(0, 2).join(', ')
const formatUsersEmails = (users) => !!users && users.length > 0 ? `${addSeparationOnEmails(users)}${users.length > 2 ? ` and +${users.slice(2, users.length).length} email${users.length === 3 ? '' : 's'}` : ''}` : '';

const columns = (isLoading: boolean) => [
  { name: 'Email type', width: '180px', sortable: true, ...tableLoading('displayName', isLoading, 100) },
  { name: 'Category', sortable: true, width: '120px', ...tableLoading('category', isLoading, 80) },
  { name: 'Recipients', width: '480px', ...tableLoading('usersToSend', isLoading, 80) },
  { name: 'Actions', width: '180px', ...tableLoadingButton('edit', isLoading, 'Edit') }
];

const EmailsConfigurationTable: React.SFC<IEmailCategoryProps> = (props) => {
  const { emailsConfiguration, loading, onHandleModal } = props;
  const loadingArray = React.useRef(times(8, Object));
  const tableEmailsConfiguration = emailsConfiguration.map((email) => ({
    ...email,
    usersToSend: formatUsersEmails(email.usersToSend),
    edit:
      <Button
        className="btn-blue float-right"
        disabled={email.emailId === IEmailTypes.WELCOME || email.emailId === IEmailTypes.TRANSFERCASE}
        onClick={() => onHandleModal(email.emailId)}
      >
        Edit
      </Button>
  }));
  return (
    <DataTable
      columns={columns(loading)}
      data={loading ? loadingArray.current : tableEmailsConfiguration}
      highlightOnHover={true}
      className="application-emailsConfiguration__table"
      fixedHeader={false}
      responsive={false}
      noHeader={true}
      subHeader={false}
      pagination={false}
    />
  );
}

export default EmailsConfigurationTable;
